import type { CryptocurrencyInfoType } from '@web/app/[locale]/(web)/trade/action';

/**
 * CMC/Contentful 조회 키가 되는 심볼 base 자산명.
 * positionUnit ?? baseCurrency ?? currency 순으로 fallback한다.
 */
export const resolveTokenCurrency = (
  info: { positionUnit?: string | null; baseCurrency?: string | null; currency?: string | null } | undefined | null,
): string | undefined => info?.positionUnit || info?.baseCurrency || info?.currency || undefined;

/**
 * Read more(소개글 모달)를 노출할지 여부.
 * RWA는 소개글이 없으므로 항상 false, 그 외에는 소개글이 2문단 이상일 때만 true.
 */
export const computeHasReadMore = (cryptocurrencyInfo: CryptocurrencyInfoType | undefined, isRwa: boolean): boolean => {
  if (isRwa) return false;
  return (cryptocurrencyInfo?.description?.json.content.length ?? 0) > 1;
};
